import { lazyLoadWithRetry } from "utilities/react.utilities";
import { routes } from "utilities/routes";

import { BTSuspense } from "commonComponents/btWrappers/BTSuspense/BTSuspense";
import { RouteRelative } from "commonComponents/utilities/RouteRelative/RouteRelative";

import { type ICostGroupProps } from "./CostGroup";

const CostGroup = lazyLoadWithRetry(() => import("./CostGroup"));

export const RouteCostGroup = (
    props: Omit<ICostGroupProps, "id" | "history" | "location" | "match">,
) => (
    <RouteRelative
        path={routes.costCatalog.costGroupDetailsPath}
        render={(routeProps) => {
            return (
                <BTSuspense>
                    <CostGroup {...props} {...routeProps} id={+routeProps.match.params.id} />
                </BTSuspense>
            );
        }}
    />
);
